const FinanceProductEnum = {
  MONEY_SAVER: 'MONEY_SAVER',
  LEGACY: 'LEGACY',
};

export default FinanceProductEnum;
